import MainLayout from "components/templates/MainLayout"

const Clients = () => {
  return <MainLayout navigation />
}

export default Clients
